const moduleName = 'utils';

const isVisible = (elem) => elem.offsetWidth > 0 || elem.offsetHeight > 0;

export { isVisible };
